import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { BadgeSize, BadgeType } from '@mwe/models';

const SizingThemes = {
  micro: {
    gapClass: '',
    badgeClass: 'badge-mc',
  },
  xs: {
    gapClass: 'gap-2',
    badgeClass: 'badge-xs',
  },
  sm: {
    gapClass: 'gap-2',
    badgeClass: 'badge-sm',
  },
  md: {
    gapClass: 'gap-12px',
    badgeClass: 'badge-md',
  },
  lg: {
    gapClass: 'gap-12px',
    badgeClass: 'badge-lg',
  },
};

const ColorSchemes = {
  success: {
    subtle: {
      backgroundClass: 'bg-green-010',
      iconColorClass: 'text-success',
      textColorClass: 'text-neutral-800',
    },
    bold: {
      backgroundClass: 'bg-success',
      iconColorClass: 'text-white',
      textColorClass: 'text-white',
    },
  },
  danger: {
    subtle: {
      backgroundClass: 'bg-red-050',
      iconColorClass: 'text-red-600',
      textColorClass: 'text-neutral-800',
    },
    bold: {
      backgroundClass: 'bg-red-600',
      iconColorClass: 'text-white',
      textColorClass: 'text-white',
    },
  },
  info: {
    subtle: {
      backgroundClass: 'bg-blue-050',
      iconColorClass: 'text-secondary-light',
      textColorClass: 'text-neutral-800',
    },
    bold: {
      backgroundClass: 'bg-secondary-light',
      iconColorClass: 'text-white',
      textColorClass: 'text-white',
    },
  },
  warning: {
    subtle: {
      backgroundClass: 'bg-yellow-050',
      iconColorClass: 'text-yellow-300',
      textColorClass: 'text-neutral-800',
    },
    bold: {
      backgroundClass: 'bg-yellow-200',
      iconColorClass: 'text-neutral-700',
      textColorClass: 'text-neutral-800',
    },
  },
  brand: {
    subtle: {
      backgroundClass: 'bg-orange-100',
      iconColorClass: 'text-primary',
      textColorClass: 'text-neutral-800',
    },
    bold: {
      backgroundClass: 'bg-primary',
      iconColorClass: 'text-white',
      textColorClass: 'text-white',
    },
  },
  neutral: {
    subtle: {
      backgroundClass: 'bg-neutral-010',
      iconColorClass: 'text-neutral-600',
      textColorClass: 'text-neutral-800',
    },
    bold: {
      backgroundClass: 'bg-neutral-500',
      iconColorClass: 'text-white',
      textColorClass: 'text-white',
    },
  },
};

@Component({
  selector: 'mwe-badge',
  templateUrl: './badge.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, TranslatePipe],
})
export class BadgeComponent {
  text = input<string>();
  type = input.required<BadgeType>();
  emphasis = input.required<'bold' | 'subtle'>();
  size = input.required<BadgeSize>();
  iconClass = input<string>();

  sizingTheme = computed(() => {
    return SizingThemes[this.size()];
  });
  colorScheme = computed(() => {
    return ColorSchemes?.[this.type()]?.[this.emphasis()];
  });
}
